import { api, unwrap } from '@/api'
import type { ApprovalStatus } from '@/features/auth/types'
import type {
  CustomerApprovalHistoryItem,
  CustomerDashboardData,
  CustomerPermissionsSummary,
  CustomerSubscriptionSummary,
} from '../types/customer.types'

export const customerService = {
  async getDashboard(): Promise<CustomerDashboardData> {
    const res = await api.get<CustomerDashboardData>('/customer/dashboard')
    return unwrap(res)
  },

  async getApprovalStatus(): Promise<{ approvalStatus: ApprovalStatus }> {
    const res = await api.get<{ approvalStatus: ApprovalStatus }>('/customer/approval-status')
    return unwrap(res)
  },

  async getSubscription(): Promise<CustomerSubscriptionSummary | null> {
    const res = await api.get<CustomerSubscriptionSummary | null>('/customer/subscription')
    return unwrap(res)
  },

  async getPermissions(): Promise<CustomerPermissionsSummary> {
    const res = await api.get<CustomerPermissionsSummary>('/customer/permissions')
    return unwrap(res)
  },

  async getSubmissionHistory(): Promise<CustomerApprovalHistoryItem[]> {
    const res = await api.get<CustomerApprovalHistoryItem[]>('/customer/approval/history')
    return unwrap(res)
  },

  async submitSellerRequest(payload: any): Promise<CustomerApprovalHistoryItem> {
    const res = await api.post<CustomerApprovalHistoryItem>('/platform/approval/seller', payload)
    return unwrap(res)
  },

  async submitDealerRequest(payload: any): Promise<CustomerApprovalHistoryItem> {
    const res = await api.post<CustomerApprovalHistoryItem>('/platform/approval/dealer', payload)
    return unwrap(res)
  },

  async getFormConfig(formType: 'SELLER' | 'DEALER') {
    const res = await api.get(`/platform/form-config/${formType}`)
    return unwrap(res)
  },

  async getPublicPlans() {
    const res = await api.get('/platform/plans')
    return unwrap(res)
  },
}
